import { z } from "zod";
import { overviewContainerViewSchema, overviewMetaContainerSchema } from "./shared.js";
// Each workflow's overview projects onto a fixed, per-workflow container contract. A required role KEY
// means the workflow owns that role (capability: it can render a chip/field for it); a `null`
// VALUE means the workflow owns the role but the reference is confirmed-absent or never carried
// by this specific claim. A projector that forgets a role fails to typecheck — see
// `projectCostEstimateOverview` and friends in ./costEstimateDamageAppraisal.ts / ./invoice.ts,
// which build their `containers` object against `z.infer<contract>` and so cannot silently omit
// one.
export const costEstimateOverviewContractSchema = z.object({
    incident: overviewContainerViewSchema.nullable(),
    automaticDispatches: overviewContainerViewSchema.nullable(),
    personType: overviewContainerViewSchema.nullable(),
    eventLocation: overviewContainerViewSchema.nullable(),
    repairProcedure: overviewContainerViewSchema.nullable(),
    damage: overviewContainerViewSchema.nullable(),
    lawyer: overviewContainerViewSchema.nullable(),
    itemData: overviewContainerViewSchema.nullable(),
    insurance: overviewContainerViewSchema.nullable(),
    leasing: overviewContainerViewSchema.nullable(),
    linkedIncidents: overviewContainerViewSchema.nullable(),
    personComplete: overviewContainerViewSchema.nullable(),
    garageAddress: overviewContainerViewSchema.nullable(),
    garageDispatches: overviewContainerViewSchema.nullable(),
    estimate: overviewMetaContainerSchema.nullable(),
    commissionedExpertReport: overviewMetaContainerSchema.nullable(),
    expertReport: overviewMetaContainerSchema.nullable(),
});
export const damageAppraisalOverviewContractSchema = costEstimateOverviewContractSchema.omit({
    garageAddress: true,
    garageDispatches: true,
});
export const invoiceOverviewContractSchema = z.object({
    incident: overviewContainerViewSchema.nullable(),
    repairProcedure: overviewContainerViewSchema.nullable(),
    automaticDispatches: overviewContainerViewSchema.nullable(),
    personType: overviewContainerViewSchema.nullable(),
    damage: overviewContainerViewSchema.nullable(),
    itemData: overviewContainerViewSchema.nullable(),
    linkedIncidents: overviewContainerViewSchema.nullable(),
    personComplete: overviewContainerViewSchema.nullable(),
    garageAddress: overviewContainerViewSchema.nullable(),
    estimate: overviewMetaContainerSchema.nullable(),
    commissionedExpertReport: overviewMetaContainerSchema.nullable(),
    expertReport: overviewMetaContainerSchema.nullable(),
});
